import Vue from 'vue'

const KEY = 'onboarding_state'
const DEMO_ENABLED_KEY = 'onboarding_demo_enabled'
const DEMO_NEXT_KEY = 'onboarding_next'
const DEMO_FLOWS = ['contacts-dashboard', 'contact-form', 'movies-list', 'movie-form']

const onboardingDemoState = Vue.observable({
  enabled: false,
  progressVersion: 0,
})

function syncOnboardingDemoEnabled() {
  if (typeof window === 'undefined') return

  onboardingDemoState.enabled = window.sessionStorage.getItem(DEMO_ENABLED_KEY) === 'true'
}

function touchOnboardingDemoProgress() {
  onboardingDemoState.progressVersion += 1
}

export function isDone(flow) {
  const state = JSON.parse(sessionStorage.getItem(KEY) || '{}')
  return state[flow]
}

export function markDone(flow) {
  const state = JSON.parse(sessionStorage.getItem(KEY) || '{}')
  state[flow] = true
  sessionStorage.setItem(KEY, JSON.stringify(state))
  touchOnboardingDemoProgress()
}

export function clearDone(flow) {
  const state = JSON.parse(sessionStorage.getItem(KEY) || '{}')
  delete state[flow]
  sessionStorage.setItem(KEY, JSON.stringify(state))
  touchOnboardingDemoProgress()
}

export function getOnboardingDemoState() {
  syncOnboardingDemoEnabled()
  return onboardingDemoState
}

export function isOnboardingDemoEnabled() {
  syncOnboardingDemoEnabled()
  return onboardingDemoState.enabled
}

export function setOnboardingDemoEnabled(enabled) {
  if (typeof window === 'undefined') return

  if (enabled) {
    window.sessionStorage.setItem(DEMO_ENABLED_KEY, 'true')
  } else {
    window.sessionStorage.removeItem(DEMO_ENABLED_KEY)
  }

  onboardingDemoState.enabled = enabled
  touchOnboardingDemoProgress()
}

export function hasOnboardingDemoProgress() {
  const state = JSON.parse(sessionStorage.getItem(KEY) || '{}')
  const completedFlowsCount = DEMO_FLOWS.filter(flow => state[flow]).length
  const hasNextRoute = Boolean(sessionStorage.getItem(DEMO_NEXT_KEY))

  return hasNextRoute || (completedFlowsCount > 0 && completedFlowsCount < DEMO_FLOWS.length)
}

export function getNextOnboardingDemoStepId() {
  const nextStep = sessionStorage.getItem(DEMO_NEXT_KEY)

  if (nextStep === 'contact-form' || nextStep === 'movies-list' || nextStep === 'movie-form') {
    return nextStep
  }

  return DEMO_FLOWS.find(flow => !isDone(flow)) || null
}

export function resetOnboardingDemoProgress() {
  sessionStorage.removeItem(KEY)
  sessionStorage.removeItem(DEMO_NEXT_KEY)
  localStorage.removeItem(DEMO_NEXT_KEY)
  touchOnboardingDemoProgress()
}

export function resetOnboardingState() {
  resetOnboardingDemoProgress()
}
